<template>
  <div class="filtro-horizontal col s12 pt-1">
    <div
      class="col s12 valign-wrapper pb-1"
      style="justify-content: center;"
      v-if="filters && filters.length > 0"
    >
      <div class="hide-on-small-only col s12 m3 pa-0"></div>

      <!-- Filtros com submenus -->
      <div class="filtros-horizontais col s12 m5 pa-0">
        <div
          class="col s12 m3 pa-0 center"
          v-for="(filter, index) in filters.filter(f => f.subMenus.length > 0)"
          :key="index"
        >
          <a
            class="dropdown-button btn btn-flat"
            :class="{
              'primary-color-text': !(filter.subMenus.find(k => k === filtroMenuHorizontal)),
              'primary-color white-text': filter.subMenus.find(k => k === filtroMenuHorizontal)
            }"
            href="#!"
            :data-activates="`dropdown${index}`"
            style="padding-left: 8px; padding-right: 8px; border-radius: 6px;"
          >
            {{ filter.menu }}
            <i class="material-icons right" style="pointer-events: none; height: 23px; line-height: 35px;">expand_more</i>
          </a>
          <ul :id="`dropdown${index}`" class="dropdown-content">
            <li
              v-for="(sub, ind2) in filter.subMenus"
              :key="ind2"
            >
              <a
                class=""
                @click.prevent="selecionarFiltro(sub)"
                :class="{ 'primary-color white-text': filtroMenuHorizontal === sub, 'primary-color-text': filtroMenuHorizontal !== sub }"
              >
                {{ sub }}
                <i class="material-icons primary-color-text right ma-0">keyboard_arrow_right</i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Botão "Todos" -->
      <div class="filtros-horizontais-todos col s12 m1 pa-0">
        <a
          class="dropdown-button btn btn-flat"
          :class="{ 'primary-color white-text': !filtroMenuHorizontal, 'primary-color-text': filtroMenuHorizontal}"
          href="#!"
          style="padding-left: 8px; padding-right: 8px; border-radius: 6px;"
          @click.prevent="limparFiltro"
        >
          Todos
        </a>
      </div>

      <div class="hide-on-small-only col s3 pa-0"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'filtro-horizontal',
  props: {
    filters: { type: Array, default: () => [] },
    filtroMenuHorizontal: { type: String, default: '' }
  },
  mounted() {
    this.$nextTick(() => {
      $('.dropdown-button').dropdown({
        inDuration: 300,
        outDuration: 225,
        constrainWidth: false,
        gutter: 5,
        belowOrigin: false,
        alignment: 'left',
        stopPropagation: false
      });
    });
  },
  methods: {
    selecionarFiltro(sub) {
      this.$emit('selecionarFiltro', sub);
      this.fecharDropdown();
    },
    limparFiltro() {
      this.$emit('selecionarFiltro', null);
    },
    fecharDropdown() {
      $('.dropdown-button').dropdown('close');
    },
  }
};
</script>


<style lang="scss" scoped>

.dropdown-content {
  &.active {
    position: fixed !important;
  }
}

.dropdown-content.active {
  position: fixed !important;
}

@media only screen and (max-width: 600px) {
  
}

</style>


// WEBPACK FOOTER //
// FiltroHorizontal.vue?3947da04